import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingSuccessComponent } from '../landing/landing-success/landing-success.component';
import { ContestSelectionComponent } from '../landing/contest-selection/contest-selection.component';
import { NflComponent } from 'src/app/welcome/nfl/nfl.component';
import { MlbComponent } from 'src/app/welcome/mlb/mlb.component';
import { NhlComponent } from 'src/app/welcome/nhl/nhl.component';
import { NbaComponent } from 'src/app/welcome/nba/nba.component';
import { NflProductComponent } from '../welcome/nfl-product/nfl-product.component';
import { IDPGuysComponent } from '../welcome/idpguys/idpguys.component';
import { OtpreceiveComponent } from '../admin-dashboard/popup/otpreceive/otpreceive.component';


const routes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  { path: 'welcome', loadChildren: () => import('../welcome/welcome.module').then(m => m.WelcomeModule) },
  { path: 'landing', loadChildren: () => import('../landing/landing.module').then(m => m.LandingModule) },
  { path: 'dashboard', loadChildren: () => import('../admin-dashboard/dashboard.module').then(m => m.DashboardModule) },
  // SG-177 Phase 10 (review-round fix): the invitation email's deep link
  // (PrivateContestServiceImpl#buildDeepLink, backend) always points at
  // user/contest-selection -- registered here, ahead of the 'user' lazy
  // module below, so this exact 2-segment path is matched first (Angular
  // route matching is array-order-dependent); every other /user/* path
  // falls through to the lazy module unaffected. See
  // contest-selection.component.ts for the auth-branch redirect logic.
  { path: 'user/contest-selection', component: ContestSelectionComponent },
  { path: 'user', loadChildren: () => import('../user-dashboard/userdashboard/userdashboard.module').then(m => m.UserdashboardModule) },
  { path: 'success', component: LandingSuccessComponent },
  { path: 'nfl', component: NflComponent },
  { path: 'mlb', component: MlbComponent },
  { path: 'nba', component: NbaComponent },
  { path: 'nhl', component: NhlComponent },
  { path: 'nfl-product', component: NflProductComponent },
  { path: 'IDPGuys', component: IDPGuysComponent },
  { path: 'otpreceive', component: OtpreceiveComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }







